export default __webpack_public_path__ + "static/media/exchange.920b91b8.svg";